import React from 'react';
import {Box, CircularProgress, Typography} from '@mui/material';

const C = {cyanDeep: '#007DB4', muted: 'var(--cpc-text-muted, rgba(0,60,105,.72))'};

/**
 * Spinner + message for an in-page loading state.
 *
 * Deliberately NOT the app-wide full-screen Loader (src/components/Loader) —
 * that one covers the whole viewport with a fixed overlay, which is right for
 * a page transition but wrong here: these loading states sit inside the
 * dashboard shell, and the sidebar/header should stay visible and usable
 * while just the content area is still loading.
 */
const CpcLoader = ({label, sx}) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.75,
            minHeight: '60vh',
            padding: '64px 20px',
            ...sx,
        }}
    >
        <CircularProgress size={34} thickness={4} sx={{color: C.cyanDeep}}/>
        {label && <Typography sx={{fontSize: 14, color: C.muted}}>{label}</Typography>}
    </Box>
);

export default CpcLoader;
